import { IDepartmentCreate, IDepartmentListSearch, IEditDepartmentPayload } from "../../../../types/master/departmentInterface";
import api from "../../../../lib/api";

export const createDepartmentApi = async (data: IDepartmentCreate) => {
  return await api.post(`/department`, data);
};

export const getDepartmentListApi = async (data: IDepartmentListSearch) => {
  return await api.get(`department/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
};

export const getDepartmentDataByIdApi = async (id: number) => {
  return await api.get(`/department/${id}`);
};

export const editDepartmentDataByIdApi = async (payload: IEditDepartmentPayload) => {
  return await api.put(`/department/${payload.id}`, payload.data);
};
